import React from 'react';

import Button from '@atlaskit/button/new';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives/compiled';
import Link from '@atlaskit/link';
import { JiraModal as ModalDialog } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import { useIntl } from '@atlassian/jira-intl';

import { LINK_PROJECTS_TO_WORK_ITEM_HELP_ARTICLE_URL } from '../constants.tsx';
import messages from './messages.tsx';

type LinkConfirmationModalProps = {
	onClose: () => void;
	onLink: () => void;
};

export const LinkConfirmationModal = ({ onClose, onLink }: LinkConfirmationModalProps) => {
	const { formatMessage } = useIntl();

	return (
		<ModalDialog
			messageId="issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.modal-dialog.confirmation-modal"
			messageType="transactional"
			onClose={onClose}
		>
			<ModalHeader hasCloseButton>
				<ModalTitle appearance="warning">{formatMessage(messages.title)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Text>
					{formatMessage(messages.description, {
						Link: (chunks: React.ReactNode) => (
							<Link href={LINK_PROJECTS_TO_WORK_ITEM_HELP_ARTICLE_URL} target="_blank">
								{chunks}
							</Link>
						),
					})}
				</Text>
			</ModalBody>

			<ModalFooter>
				<Button appearance="subtle" onClick={onClose}>
					{formatMessage(messages.cancelButton)}
				</Button>
				<Button appearance="warning" onClick={onLink}>
					{formatMessage(messages.linkButton)}
				</Button>
			</ModalFooter>
		</ModalDialog>
	);
};
